import React from "react";
import PostHeader from "../items/post/header";
import moment from "moment";
import { GcPost, GcPostActivity } from "../../types";
import { prettyDate } from "../../actions/prettyDate";

const GCPost = ({ post, activity }: { post: GcPost; activity: GcPostActivity }) => {
	const timestamp = String(moment(activity.time).unix());
	const date = prettyDate(timestamp, false);

	let imageRelativeHeight = "100%";
	if (post.photoDimensions) {
		imageRelativeHeight = (post.photoDimensions.height / post.photoDimensions.width) * 100 + "%";
	}

	return (
		<div className="nBlock newsFeedPost">
			<PostHeader
				title={!(typeof activity.actor === "string") || activity.actor === "gc" ? "GotCourts" : activity.actor}
				meta={date}
				extra={activity.federation ? activity.federation : "gotcourts"}
			/>
			{post.photoUrl ? (
				<div className="postImage" style={{ backgroundImage: "url('" + post.photoUrl + "')" }}>
					<div className="aspectRatioFill" style={{ paddingTop: imageRelativeHeight }} />
				</div>
			) : null}
			{post.title ? <div className="postTitle">{post.title}</div> : null}
			{post.text ? <div className="postText">{post.text}</div> : null}
			{post.link && post.linkName ? (
				<div className="postAction">
					<a className="button small" target="_blank" href={post.link} rel="noopener noreferrer">
						{post.linkName}
					</a>
				</div>
			) : null}
		</div>
	);
};

export default GCPost;
